const BASE = "https://static.prod-images.emergentagent.com/jobs/6cf1064c-85ef-4a34-9f64-d16106500868/images";

export const IMAGES = {
  hero_studio: `${BASE}/b57c5385b266a7e1f641dbb2f218851a4867c20dd074dba204cc3d6a01e4afb4.png`,
  bike_detail: `${BASE}/33b22b694385955362c51fcccc78bd3844b1bd012addb418796bbc8af65dc63d.png`,
  rider_silhouette: `${BASE}/0ebbf499cc32587dc34657f862e3802af862530e7096361c7cfd607c10e7b49d.png`,
  class_energy: `${BASE}/81d6132a96083b76bd319870083e3cca240c66743e8b10dec6be9d49a81c949e.png`,
  instructor_podium: `${BASE}/3979ab041d920d27ed831e2a0a0048abec349f87b0aac19d1002ffc804e5b738.png`,
  gallery_shoes: `${BASE}/ba15884ef4cdb902a3f559b2b1ad39f8fe419033484c317fdc76e18318f155eb.png`,
  gallery_lobby: `${BASE}/24cd6cc9ceefac870457fa6869fed05f097a2fd57db25abd9828594ba5eada0b.png`,
  gallery_lights: `${BASE}/582997df102a6027f1f013de44ea861066cedf7b74e54e0a40fadf6a6fa801c3.png`,
  gallery_hands: `${BASE}/fa2befc8f0614e45c7ebaeca57974992a676b0295d3d80976a02d2b664c4e63c.png`,
  founder_portrait: `${BASE}/a32423287feaf490c28540d8ef93a71c4aa90faa4e2931c9a61fd27fb5d8cdfb.png`,
  sprint_energy: `${BASE}/2e66777f5f5c5c98b1996c6487575284bde47641ee8094bd9c5b559f6cff1de8.png`,
  detail_towel: `${BASE}/284887949900f6c05f0d7d605070f430cb2adba93d2c7360027e354ff23072dd.png`,
};
